export default __webpack_public_path__ + "images/MNE.9dc268c.png";